import axios from 'axios'

export function csrfUpdater(data){
    if(data.newCSRF){
        document.querySelector('meta[name="csrf-token"]').content = data.newCSRF;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = data.newCSRF;
    }
    return data;
}
